export default __webpack_public_path__ + "static/media/250_ml_e.1f279eb6.svg";